import { BASE_FORMS_TEMPLATES_ROUTE } from './form-templates.constants';
import { getFormTemplatesListRoute, getFormTemplateDetailsRoute } from './form-templates.utils';

export const FORM_TEMPLATES_ROUTES = {
  base: BASE_FORMS_TEMPLATES_ROUTE,
  templatesList: getFormTemplatesListRoute,
  templateDetails: getFormTemplateDetailsRoute,
};
